import {observable, action, runInAction} from 'mobx'
import {get} from '../../../../utils/ajax'
import {handleSeerchAndPage} from "../../../../utils/Utils";

class ToolkitIdStore {
    @observable oneList;
    @observable tableList;
    @observable loading;
    @observable page;
    @observable search;
    @observable tableId;
    @observable level1Selected;  //一级目录当前选中的ID
    @observable pagination //分页

    constructor() {
        this.loading = false;
        this.oneList = [];
        this.tableList = [];
        this.page = {
            current: 0,
            total: 1
        };
        this.search = {
            systemId: '',
            number: '',
            name: ''    //车系ID工具名称/工具号
        };
        this.tableId = ''
        this.level1Selected = ''
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }



    /*** 改变时绑定搜索框值****/
    @action
    searchFieldsChange = (changedFields) => {
        runInAction(() => {
            this.search = {
                systemId: changedFields.systemId ? changedFields.systemId.value : this.search.systemId,
                number: changedFields.number ? changedFields.number.value : this.search.number,
                name: changedFields.name ? changedFields.name.value : this.search.name,
            }
        })
    }
    /*** 查询一级菜单数据*/
    @action
    initPage = async (id, oneListId,page) => {
        runInAction(() => {
            this.loading = true
        });
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/system/list?carseriesId=${id}`)
        runInAction(() => {
            this.oneList = res || [];
            this.loading = false
            this.level1Selected = oneListId === 'none' ? res[0].id : oneListId
        })
        const oneListIds = oneListId === 'none' ? res[0].id : oneListId
        this.searchBySystemId(oneListIds)
    }

    /***根据一级菜单替换表格数据****/
    @action
    initTable = async (temPage) => {
        runInAction(() => {
            this.loading = true
        })
        let searchValue = handleSeerchAndPage(temPage, this.pagination, this.search);
        searchValue.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/list`, searchValue)
        runInAction(() => {
            console.log(res,'----res')
            this.tableList = res.content || [];
            this.loading = false;
        })
    }
    @action
    searchBySystemId = async (id, temPage) => {
        runInAction(() => {
            this.loading = true
        })
        this.search.systemId = id
        this.tableId = id
        let searchValue = handleSeerchAndPage(temPage, this.pagination, this.search);
        searchValue.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/list`, searchValue)
        console.log(res,'----8888')
        runInAction(() => {
            this.tableList = res.content || [];
            this.level1Selected = id
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements ? res.totalElements : 0} 条`
            }
            this.loading = false;
        })
    }

    @action
    clearForm = () => {
        runInAction(() => {
            this.loading = true
            this.search = {
                number: '',
                name: ''
            }
            this.loading = false
            this.search.systemId = this.tableId
            this.searchBySystemId(this.search.systemId, this.page)
        })
    }
}

export default new ToolkitIdStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/toolkit/ToolkitId/store.js